import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export default function PaymentEditModal({ isOpen, toggle, onExpiryEdit, onReplaceCard, card }) {
  // If no card is attached
  if (!card) {
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Payment Method</ModalHeader>
        <ModalBody className="text-center text-muted">No payment method added.</ModalBody>
      </Modal>
    );
  }

  const { brand, last4, expMonth, expYear } = card;

  // Format expiry MM/YYYY
  const expiry = `${String(expMonth).padStart(2, '0')}/${expYear}`;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Payment Method</ModalHeader>

      <ModalBody>
        <div className="border rounded p-3 d-flex align-items-center justify-content-between">
          <div>
            <div className="fw-bold">•••• •••• •••• {last4}</div>
            <small className="text-muted">
              {brand} • Expires {expiry}
            </small>
          </div>

          <i
            className="fa fa-pen cursor-pointer"
            style={{ cursor: 'pointer' }}
            onClick={onExpiryEdit}
          ></i>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="primary" onClick={onReplaceCard}>
          Replace card
        </Button>
      </ModalFooter>
    </Modal>
  );
}
